export default {
  accessToken: null,
  refreshToken: null,
  loggingIn: false,
  loginError: null,
};
